import { useEffect, useState } from 'react'
import { STATICS } from '../../static'
import styled from 'styled-components'
import { useWeb3React } from '@web3-react/core'
import { useContract } from '../../hooks/useContract'
import useEnvConfig from 'hooks/useEnvConfig'
import { ABI_COCOS_TOKEN } from '../../utils/abis'
import { KeepSecimals, balanceFormat } from '../../utils'
import { useAccountAssets, AccountNFTItem, isERC721 } from '../../hooks/useMarketBussiness'
import Loading from '../../components/common/Loading'
import web3 from 'web3'

export default function MyNft() {
  const { account, chainId } = useWeb3React()
  const { assets, loading } = useAccountAssets(account)
  return (
    <ContainerMain>
      <div className="mynft-info-container">
        <ETHBalance />
        {chainId !== 137 && <CocosBalance />}
      </div>
      <NFTListWrapper>
        {loading ? (
          <Loader />
        ) : assets.length === 0 ? (
          <Empty />
        ) : (
          <NFTList>
            {assets.map((nft, key) => (
              <NFTCard key={key} nft={nft} />
            ))}
          </NFTList>
        )}
      </NFTListWrapper>
    </ContainerMain>
  )
}

function ETHBalance() {
  const { account, library } = useWeb3React()
  const { currency } = useEnvConfig()
  const [ethBalance, setEthBalance] = useState<number | string>(0)

  useEffect(() => {
    let unmounted = false
    const getBalance = async () => {
      if (account && library && !unmounted) {
        const Web3 = new web3(library.provider)
        let resAcc = await Web3.eth.getBalance(account)
        setEthBalance(KeepSecimals(balanceFormat(resAcc, currency.decimals), 3))
      }
    }
    if (account && library) {
      getBalance()
    }
    return () => {
      unmounted = true
    }
  }, [library, account, currency])

  return (
    <div className="mynft-info-main">
      <ul className="tit">Balance ({currency.symbol}):</ul>
      <ul className="con">{ethBalance}</ul>
    </div>
  )
}

function CocosBalance() {
  const { account } = useWeb3React()
  const { ADDRESS_COCOSTOKEN } = useEnvConfig()
  const cocosDecimals = 18
  const cocosContract = useContract(ADDRESS_COCOSTOKEN, ABI_COCOS_TOKEN)
  const [cocosBalance, setCocosBalance] = useState<number | string>(0)

  useEffect(() => {
    let unmounted = false
    const getBalance = async () => {
      if (cocosContract && account && !unmounted) {
        let res = await cocosContract.balanceOf(account)
        let balance = res
        balance = KeepSecimals(balanceFormat(balance, cocosDecimals), 3)
        setCocosBalance(balance)
      }
    }
    if (cocosContract && account) {
      getBalance()
    }
    return () => {
      unmounted = true
    }
  }, [cocosContract, account])

  return (
    <div className="mynft-info-main">
      <ul className="tit">Balance (COCOS):</ul>
      <ul className="con">{cocosBalance}</ul>
    </div>
  )
}

const Loader = () => (
  <LoadingWrapper>
    <Loading width={100} height={100} />
  </LoadingWrapper>
)

const Empty = () => (
  <EmptyContainer>
    <img src={STATICS.EmptyList} alt="" />
    <p>You haven't NFT</p>
  </EmptyContainer>
)

function NFTCard({ nft }: { nft: AccountNFTItem }) {
  return (
    <NFTCardWrapper href={`/nftdetail?contract=${nft.contract}&token_id=${nft.token_id}`}>
      {nft.on_sale && <OnSale />}
      <img src={nft.resource} alt="" />
      <div className="nft-info">
        <div className="name">{nft.name}</div>
        <div className="token-id">ID: {nft.token_id}</div>
        {!isERC721(nft.nft_type) && <div className="amount">Amount: {nft.amount}</div>}
      </div>
    </NFTCardWrapper>
  )
}

const EmptyContainer = styled.div`
  width: 100%;
  padding: 50px 0;
  img {
    width: 190px;
    height: 185px;
    margin: 0 auto;
    display: block;
  }
  p {
    width: 100%;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #bebebe;
    line-height: 20px;
    margin-top: 20px;
    text-align: center;
  }
`

const ContainerMain = styled.div`
  width: 1198px;
  margin: 0 auto;
  position: relative;
  .mynft-info-container {
    width: 100%;
    height: 150px;
    margin: 30px auto 0;
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 36px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: linear-gradient(360deg, #ffffff 0%, #ffffff 0%, #02277a 0%, #02277a 0%, #08318b 100%, #08318b 100%);
    border-radius: 1px 1px 1px 1px;

    .mynft-info-main {
      margin-right: 254px;
      .tit {
        height: 20px;
        font-weight: 400;
        font-size: 16px;
        color: #fffdfd;
      }
      .con {
        height: 33px;
        font-size: 30px;
        color: #ffd067;
        margin-top: 23px;
      }
    }
  }
`

const OnSale = () => <OnSaleContainer>On sale</OnSaleContainer>

const OnSaleContainer = styled.div`
  position: absolute;
  top: 13px;
  left: 11px;
  width: 73px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(150deg, #b50fc9, #d516ce, #9c15db);
  color: #fff;
  border-radius: 4px;
  font-size: 18px;
  font-family: Myriad Pro;
`
const LoadingWrapper = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const NFTListWrapper = styled.div`
  width: 1198px;
  min-height: 200px;
  background: #11388c;
  border-radius: 18px;
  padding: 44px 74px;
`
const NFTList = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(4, 225px);
  gap: 24px 50px;
`

const NFTCardWrapper = styled.a`
  position: relative;
  display: block;
  text-decoration: none;
  width: 225px;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(34, 92, 217, 0.55);
  cursor: pointer;
  img {
    width: 225px;
    height: 225px;
    object-fit: contain;
  }
  .nft-info {
    width: 100%;
    padding: 10px 18px;
    color: #fff;
    font-size: 16px;
    .name {
      font-family: Adobe Heiti Std;
      font-weight: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .token-id {
      color: #c4c5c9;
      margin-top: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .amount {
      color: #c4c5c9;
      margin-top: 10px;
    }
  }
`
